
  import { mapState } from 'vuex'
  import bankAccountDesktop from '~/mixins/common/bank-account-desktop'
  import payment from '~/mixins/common/payment'
  import finance from '~/mixins/common/pages/finance'
  import staticAmount from '~/static/json/amount.json'
  export default {
    mixins: [payment, finance, bankAccountDesktop],
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        steppers: 1,
        valid: true,
        depositOption: '',
        formData: {
          third_party_account_uuid: null
        },
        autoAmountList: ['100', '500', '1000', '10000', '50000'],
        loadingProvider: false,
        createDepositLoading: false,
        depositAmount: '',
        amount: '',
        selectedBankId: '',
        depositChannelList: [],
        channelList: {},
        pleaseSelectedBankId: false,
        currentPage: 0,
        itemsPerPage: 6,
        currentChannelPage: 0,
        channelItemsPerPage: 8
      }
    },
    computed: {
      ...mapState({
        thirdPartyPayments: state => state.themes.deposit.thirdPartyPayments,
        player: state => state.player.player,
        tempData: state => state.themes.deposit.tempData,
        checkExist: state => state.themes.deposit.checkExist
      }),
      selectAmount() {
        const res = staticAmount.find(value => value.currency === this.$cookie.get('currency'))
        return res.amount
      },
      disabledNextButton() {
        if (!this.depositOption) return true
        if (!this.formData?.third_party_account_uuid) return true
        if (!this.selectedBankId) return true
        return false
      },
      totalPages() {
        const allOptions = this.thirdPartyPayments
        return Math.ceil(allOptions.length / this.itemsPerPage)
      },
      totalChannelPages() {
        return Math.ceil(this.depositChannelList.length / this.channelItemsPerPage)
      },
      paginatedPayments() {
        const startIndex = this.currentPage * this.itemsPerPage
        const endIndex = startIndex + this.itemsPerPage
        return this.thirdPartyPayments.slice(startIndex, endIndex)
      },
      paginatedChannels() {
        const startIndex = this.currentChannelPage * this.channelItemsPerPage
        const endIndex = startIndex + this.channelItemsPerPage
        return this.depositChannelList.slice(startIndex, endIndex)
      },

      amountErrorMessage() {
        if (!this.depositAmount) return null

        const minDeposit = parseFloat(this.channelList?.min_deposit || 50)
        const maxDeposit = parseFloat(this.channelList?.max_deposit || 1000)
        const currency = this.player?.currency || ''

        const numericValue = parseFloat(this.depositAmount.replaceAll(',', ''))

        // don't allow decimal values; BZ requirements

        if (this.depositAmount?.toString()?.includes('.')) {
          return this.tr(this.FRONTEND_ERROR_CODES.decimalIsNotAllowed)
        }

        if (numericValue < minDeposit) {
          return `${this.tr(
            this.FRONTEND_ERROR_CODES.amountMustBeGreatThan
          )} ${this.formatCurrencyJS(minDeposit)} ${currency}`
        }

        if (numericValue > maxDeposit) {
          return `${this.tr(
            this.FRONTEND_ERROR_CODES.amountMustBeLessThan
          )} ${this.formatCurrencyJS(maxDeposit)} ${currency}`
        }

        if (!this.decimalRule(this.depositAmount)) {
          return this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        }

        return null
      }
    },
    watch: {
      thirdPartyPayments(value) {
        if (value?.length > 0) {
          this.depositOption = value[0].id
          this.depositChannelList = value[0]?.channels
        }
      },
      depositOption(value) {
        if (value) {
          const channelList = this.thirdPartyPayments.find(el => el.id === value)

          this.depositChannelList =
            channelList?.channels?.map(channel => ({
              ...channel,
              tp_id: channelList.tp_id
            })) || []
        }
      },
      depositChannelList(value) {
        if (value?.length > 0) {
          this.formData.third_party_account_uuid = value[0].id
        }
      },
      'formData.third_party_account_uuid'(value) {
        if (value) {
          const chList = this.depositChannelList.find(el => el.id === value)
          this.channelList = chList ?? {}
        }
      },
      checkExist(value) {
        this.$emit('onlinePaymentConfirm', value?.is_exist)
        if (value.is_exist) {
          this.onlineBankCheckIsExist(value)
        } else {
          this.steppers = 1
        }
      }
    },
    mounted() {
      this.thirdPartyDepositChannel = new BroadcastChannel('third-party-deposit')
      this.fetchingProviders()
      this.$emit('onlinePaymentConfirm', this.checkExist?.is_exist)
      if (this.checkExist?.is_exist) {
        this.onlineBankCheckIsExist(this.checkExist)
      }
    },
    beforeDestroy() {
      if (this.thirdPartyDepositChannel) {
        this.thirdPartyDepositChannel.close()
      }
    },
    methods: {
      timeFormat(value) {
        return ('0' + parseInt(value || '00')).slice(-2)
      },
      async fetchingProviders() {
        if (this.thirdPartyPayments.length !== 0) {
          if (this.thirdPartyPayments?.length > 0) {
            this.depositOption = this.thirdPartyPayments[0].id
          }
          return
        }
        this.loadingProvider = true
        await this.$store.dispatch('themes/deposit/getThirdPartyPayments')
        this.loadingProvider = false
      },
      async onConfirmAndPay() {
        if (this.$refs.form.validate()) {
          // Track Events if not first deposit
          await this.trackThirdPartyDepositEvent(
            this.checkExist.sequence,
            this.formData.amount,
            this.selectedBankId
          )

          if (!this.selectedBankId) {
            this.pleaseSelectedBankId = true
            return
          }
          const form = {
            amount: this.formData.amount,
            third_party_account_uuid: this.formData.third_party_account_uuid
          }
          if (
            this.bankAccount?.player_bank_accounts?.length > 0 &&
            this.channelList?.is_require_bank
          ) {
            form.player_bank_account_id = this.selectedBankId
          }
          this.createDepositLoading = true
          const response = await this.$store.dispatch('themes/deposit/openDepositThirdParty', form)
          if (response) {
            this.thirdPartyDepositChannel.onmessage = event => {
              this.createDepositLoading = false
              if (event.data.success) {
                this.$emit('onlinePaymentConfirm', true)
                this.steppers = this.steppers + 1
                this.$emit('cryptoTransferConfirm', true)
              } else if (event?.data?.error_code) {
                this.$toast.error(
                  parseFloat(this.tr(event.data.error_code)) === event.data.error_code
                    ? event.data.message
                    : this.tr(event.data.error_code)
                )
              }
            }
          }
        }
      },
      onlineBankCheckIsExist(data) {
        if (data.is_exist) {
          this.steppers = 2
        }
      },
      clearForm() {
        this.depositAmount = ''
      },
      onInputAmount(amount, key) {
        if (isNaN(amount?.toString()?.replace(/,/g, ''))) {
          this.formData[key] = '0'
          return
        }
        if (key === 'amount') {
          this.depositAmount = this.customFormatNumber(amount?.toString()?.replace(/,/g, ''))
          this.formData[key] = this.depositAmount?.toString()?.replace(/,/g, '')
        }
      },
      onSelectAmount(amount) {
        this.amount = amount?.toString()
        this.depositAmount = this.customFormatNumber(amount?.toString()?.replace(/,/g, ''))
        this.formData.amount = amount?.toString()
      },
      formatNumber(number) {
        return this.customFormatNumber(number?.toString()?.replace(/,/g, ''))
      },
      navigatePage(direction) {
        const newPage = this.currentPage + direction
        if (newPage >= 0 && newPage < this.totalPages) {
          this.currentPage = newPage
        }
      },
      navigateChannelPage(direction) {
        const newPage = this.currentChannelPage + direction
        if (newPage >= 0 && newPage < this.totalChannelPages) {
          this.currentChannelPage = newPage
        }
      }
    }
  }
